import axios from 'axios'

export default {
    namespaced: true,
    state: {
        housingApplication: {},
    },
    mutations: {
        SET_HOUSING_APPLICATION(state, payload) {
            state.housingApplication = payload;
        },
    },
    actions: {
        async FetchHousingApplication({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/housing/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            response.data.payload = HydratePayload(response.data.payload);

                            commit('SET_HOUSING_APPLICATION', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchHousingApplication: ${error.message}`));
            });
        },
        async InsertHousingApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/housing/insert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`InsertHousingApplication: ${error.message}`));
            });
        },
        async UpdateHousingApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/housing/update`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`UpdateHousingApplication: ${error.message}`));
            });
        },
        async UpdateHousingApplicationBypassEvidenceFields({ }, obj) {
            obj.BypassEvidenceFields = StringifyJSON(obj.BypassEvidenceFields);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/housing/update/bypass-evidence-fields`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`UpdateHousingApplicationBypassEvidenceFields: ${error.message}`));
            });
        },
        async UpdateHousingApplicationLastPageAccessed({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/housing/update/last-page-accessed`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        //else reject(response.data.message);
                    }).catch(error => reject(`UpdateHousingApplicationLastPageAccessed: ${error.message}`));
            });
        },
        async SubmitHousingApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/housing/submit`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`SubmitHousingApplication: ${error.message}`));
            });
        },
        async CancelHousingApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/housing/cancel`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`CancelHousingApplication: ${error.message}`));
            });
        },
        async DeleteHousingApplication({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/housing/delete`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`DeleteHousingApplication: ${error.message}`));
            });
        },
    },
    getters: {
        HousingApplication(state) { return state.housingApplication; },
    }
};

function HydratePayload(payload) {
    if (payload != null) {
        payload.benefitsReceived = CoalesceJSON(payload.benefitsReceived);
        payload.careExperienceTypes = CoalesceJSON(payload.careExperienceTypes);
        payload.childrenDetails = CoalesceJSON(payload.childrenDetails);
        payload.overrideEvidenceFields = CoalesceJSON(payload.overrideEvidenceFields);
        payload.requiredEvidenceFields = CoalesceJSON(payload.requiredEvidenceFields);
        payload.bypassEvidenceFields = CoalesceJSON(payload.bypassEvidenceFields);
    }

    return payload;
}
function DehydratePayload(payload) {
    if (payload != null) {
        payload.benefitsReceived = StringifyJSON(payload.benefitsReceived);
        payload.careExperienceTypes = StringifyJSON(payload.careExperienceTypes);
        payload.childrenDetails = StringifyJSON(payload.childrenDetails);
        payload.overrideEvidenceFields = StringifyJSON(payload.overrideEvidenceFields);
        payload.requiredEvidenceFields = StringifyJSON(payload.requiredEvidenceFields);
        payload.bypassEvidenceFields = StringifyJSON(payload.bypassEvidenceFields);
    }

    return payload;
}
function StringifyJSON(object) {
    if (object == null) return null;
    else if (typeof object == 'string') return object;
    else return JSON.stringify(object);
};
function CoalesceJSON(object, returnObject) {
    if (object == null || object == '') return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};

